module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "flex-center pd-25 color-fff main-top",
    style: ({
      background: _vm.selectType == 0 ? '#FF8500' : '#FF4242'
    })
  }, [_c('div', {
    staticClass: "top-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex1 ml-25 mr-25"
  }, [_c('div', {
    staticClass: "fs-32 font-bold"
  }, [_vm._v(_vm._s(_vm.entity.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "flex fs-28 mt-10"
  }, [_c('div', [_vm._v("数量：" + _vm._s(_vm.entity.totalRfidCount))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": ".5rem"
    }
  }, [_vm._v("种类：" + _vm._s(_vm.entity.totalTypeCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "fs-32 font-bold"
  }, [_vm._v("待处理")])]), _vm._v(" "), _c('div', {
    staticClass: "product-list"
  }, _vm._l((_vm.entity.itemList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "product-item fs-26"
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      attrs: {
        "src": item.mainPicView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "color-000 text-el"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "mt-10 color-999"
    }, [_vm._v("数量: "), _c('span', {
      staticClass: "color-warning"
    }, [_vm._v(_vm._s(item.rfidCount))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-5 color-999"
    }, [_vm._v(_vm._s(_vm.selectType == 0 ? '剩余' : '过期') + "天数: "), _c('span', {
      staticClass: "color-warning"
    }, [_vm._v(_vm._s(item.residueDay) + "天")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bot-address"
  }, [_c('div', {
    staticClass: "alifont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-28"
  }, [_vm._v(_vm._s(_vm.entity.address))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd8c27f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/warning/overDateDetail.vue
// module id = Sj9Y
// module chunks = 51